import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULT_CFG = {
  preview_mode: false,
  self_signup_enabled: false,
  microsoft_configured: false,
  drive_configured: false,
  email_delivery_enabled: false,
  approved_email_domain: "gklasvegas.com",
  loading: true,
};

const ConfigCtx = createContext(DEFAULT_CFG);

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULT_CFG);
  useEffect(() => {
    api.get("/config")
      .then((r) => setCfg({ ...DEFAULT_CFG, ...r.data, loading: false }))
      .catch(() => setCfg({ ...DEFAULT_CFG, loading: false }));
  }, []);
  return <ConfigCtx.Provider value={cfg}>{children}</ConfigCtx.Provider>;
}

export const useConfig = () => useContext(ConfigCtx);
